//
//
//

import vModal from '@/core/vModal'
export default {
  name: 'VModal',
  extends: vModal,
  methods: {
  }
}
